import React, { createContext, useContext, useEffect } from 'react';
import { VIBANA } from '../constants/colors';

const ThemeContext = createContext({ VB: VIBANA });

export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
  }, []);

  return (
    <ThemeContext.Provider value={{ VB: VIBANA, theme: 'dark', resolvedTheme: 'dark' }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}

export default ThemeContext;
